<ziro-collapsible-section-card
  class="animate__animated animate__fadeIn animate__faster"
  data-automation="transfer-public-component"
  [isSwitchHidden]="true"
  [isCollapsible]="false"
>
  <div class="card-header">
    <legend class="bottom-buffer mt-0 pb-2 d-flex">
      <ziro-stacked-icon
        class="icon-sm"
        [stackedIcon]="ZiroStackedIcons[ziroIcons.MAKE_PUBLIC]"
        parentClass="fa-stack"
      ></ziro-stacked-icon>

      <div class="d-flex flex-column">{{ 'tkey;transfer.menu.to.public' | translate }}</div>
    </legend>

    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
    @if (!isLoading) {
      <div>
        @if (showVoicemailCard) {
          <div class="pb-2">
            <h3>
              {{ 'tkey;pages.details.transfer.keep.voicemail.prompt' | translate }}
            </h3>
            <p>
              <strong>{{ 'tkey;pages.details.transfer.keep.voicemail.subheader.note.text' | translate }}</strong>
              {{ 'tkey;pages.details.transfer.keep.voicemail.subheader.text' | translate }}
            </p>
          </div>
        }
        @if (!showVoicemailCard) {
          <div class="pb-2">
            <p>
              {{ 'tkey;transfer.userToPublic.confirmation.text' | translate }}
            </p>
            <p>
              <strong>{{ 'tkey;transfer.confirmation.continue.text' | translate }}</strong>
            </p>
          </div>
        }
        <div class="text-end pb-2 border-top pt-3">
          <ziro-button
            [dataAutomation]="'transfer-public-cancel-button'"
            [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
            [label]="'tkey;dialogs.button.cancel'"
            [cssClass]="'me-1'"
            [isDisabled]="isSubmitting"
            (clicked)="onCancelClicked()"
          ></ziro-button>
          @if (showVoicemailCard) {
            <ziro-button
              [dataAutomation]="'delete-voicemail-button'"
              [iconPending]="ziroIcons.SAVING"
              [buttonStyle]="buttonStyles.OUTLINE_DANGER"
              [cssClass]="'me-1'"
              [label]="'tkey;pages.details.transfer.keep.voicemail.delete.button'"
              [isDisabled]="isSubmitting"
              (clicked)="onVoicemailButtonClicked(false)"
            ></ziro-button>
          }
          @if (showVoicemailCard) {
            <ziro-button
              [dataAutomation]="'keep-voicemail-button'"
              [iconPending]="ziroIcons.SAVING"
              [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
              [cssClass]="'me-1'"
              [label]="'tkey;pages.details.transfer.keep.voicemail.keep.button'"
              [isDisabled]="isSubmitting"
              (clicked)="onVoicemailButtonClicked(true)"
            ></ziro-button>
          }
          @if (!showVoicemailCard) {
            <ziro-button
              [isPending]="isSubmitting"
              [dataAutomation]="'transfer-public-reassign-button'"
              [iconPending]="ziroIcons.SAVING"
              [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
              [label]="'tkey;transfer.transferBtn.text'"
              [isDisabled]="isSubmitting"
              (clicked)="onReassignClicked()"
            ></ziro-button>
          }
        </div>
      </div>
    }
  </div>
</ziro-collapsible-section-card>
